<template>
  <header
    class="header head_main"
    :class="{ bg_gr: $route.meta.header.bgGr }"
    v-if="$route.meta.header"
  >
    <div class="inner" :class="{ inner_start: $route.meta.header.titleLeft }">
      <div class="head_logo" v-if="$route.meta.header.logo">
        <img
          src="@/assets/front/images/v2/logos/logo_perce_header.svg"
          alt="perce"
        />
      </div>
      <div
        class="head_back"
        v-if="$route.meta.header.left"
        @click="handleBack()"
      >
        <button class="h_btn_back"></button>
      </div>
      <div
        class="head_back"
        v-if="$route.meta.header.leftMain"
        @click="handleMain()"
      >
        <button class="h_btn_back"></button>
      </div>
      <div class="head_ttl">
        <img
          src="@/assets/front/images/v2/service/ic_mainservice_internet_header.svg"
          v-if="$route.meta.header.titleInternetImg"
        />
        <img
          src="@/assets/front/images/v2/service/ic_mainservice_phone_header.svg"
          v-if="$route.meta.header.titleMobileImg"
        />
        <img
          src="@/assets/front/images/v2/service/ic_mainservice_phone_header.svg"
          v-if="$route.meta.header.titleImg"
        />
        <h1 v-if="$route.meta.header.title" id="headerTitle">
          {{ headerTitle }}
          <span
            class="info_1"
            v-if="$route.meta.header.info_1"
            @click="estimateInfoModal($route.meta.header.listType)"
            >ⓘ 견적 받은 다음엔?
          </span>
        </h1>
      </div>
      <div
        v-if="$route.meta.header.area"
        class="head_place_btn_wrap"
        @click="handleRegion"
      >
        <button class="place_btn" v-if="user.emdAreaNameShort">
          {{ user.emdAreaNameShort }}
        </button>
        <button class="place_arrow_btn" v-if="user.emdAreaNameShort">
          <img
            :src="require('@/assets/front/images/new/ar_ttl_shop_bl.svg')"
            alt=""
          />
        </button>
      </div>

      <div class="head_btn">
        <button
          class="head_btn_close"
          v-if="$route.meta.header.closeBtn"
          @click="handleClose($route.meta.header.closeLinkName)"
        ></button>
        <button
          class="head_btn_srch"
          v-if="$route.meta.header.searchBtn"
          @click="handleSearch"
        ></button>
        <button
          class="head_btn_my"
          v-if="$route.meta.header.myBtn"
          @click="handleMyPage"
        ></button>
        <label
          class="h_btn btn_like"
          @click.stop.prevent="toggleFollow(shop, shop.id)"
          v-if="$route.meta.header.like"
          ><input type="checkbox" v-model="shop.followed" />
          <span class="i_heart2"></span>
        </label>
        <button
          class="h_btn leave"
          @click.prevent="handleExitChatroom()"
          v-if="$route.meta.header.leave"
        ></button>
        <button
          class="head_my_share"
          v-if="isCheckMobile && $route.meta.header.shareBtn"
          @click="handleShare"
        ></button>
        <div
          class="head_knowhow_my_btn"
          v-if="$route.meta.header.knowhowMy"
          @click="handleKnowhowMy"
        >
          <img
            :src="require(`@/assets/front/images/i_c_document_g.svg`)"
            alt=""
          />
          <p>내 작성 글</p>
        </div>
      </div>

      <!-- <div class="left">
        <button
          class="h_btn i_back"
          v-if="$route.meta.header.left"
          @click="handleBack()"
        ></button>
        <button
          class="h_btn i_back"
          v-if="$route.meta.header.leftMain"
          @click="handleMain()"
        ></button>
      </div> -->
      <!-- <h1 class="h1" v-if="$route.meta.header.title" id="headerTitle">
        {{ headerTitle }}
      </h1> -->
      <!-- <div class="right" v-if="$route.meta.header.right">
        <label
          class="h_btn btn_like"
          @click.stop.prevent="toggleFollow(shop, shop.id)"
          v-if="$route.meta.header.like"
          ><input type="checkbox" v-model="shop.followed" />
          <span class="i_heart2"></span>
        </label>
        <button
          class="h_btn leave"
          @click.prevent="handleExitChatroom()"
          v-if="$route.meta.header.leave"
        ></button>
      </div> -->
    </div>
  </header>
</template>

<script>
import { checkMobile, isApp } from '@common/lib/common/utils';

import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import {
  mapActions as userMapActions,
  mapState as userMapState,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import * as shopGetters from '@common/store/modules/shop/getters';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';
export default {
  data() {
    return {};
  },
  mounted() {
    // if (this.$refs.pageHeader) {
    //   const pageHeader = this.$refs.pageHeader.clientHeight || 50;
    //   window.headerHeight = pageHeader; //todo fix
    // }
  },
  computed: {
    ...commonMapGetters({
      customHeaderText: commonGetters.CUSTOM_HEADER_TEXT,
    }),
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...userMapGetters({
      userMain: userTypes.USER_MAIN,
      user: userTypes.USER,
    }),
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    pushInfo() {
      return this.userMain && this.userMain.pushInfo
        ? this.userMain.pushInfo
        : {};
    },
    isAlarm() {
      const {
        cntNonAdmin,
        cntNonNotice,
        cntNonBaecha,
        cntNonBonus,
        cntNonViolation,
        cntNonDaycheck,
      } = this.pushInfo;

      const cnt =
        (cntNonAdmin || 0) +
        (cntNonNotice || 0) +
        (cntNonBaecha || 0) +
        (cntNonBonus || 0) +
        (cntNonViolation || 0) +
        (cntNonDaycheck || 0);
      return cnt;
    },
    headerTitle() {
      let title = '';
      if (this.$route.meta.header.title) {
        title =
          typeof this.$route.meta.header.title === 'function'
            ? this.$route.meta.header.title(this.$route)
            : this.$route.meta.header.title;
      }
      // if (this.$route.params.termsType || this.$route.query.termsType) {
      //   if (
      //     this.$route.params.termsType === 'personal' ||
      //     this.$route.query.termsType === 'personal'
      //   ) {
      //     title = 'common.privacy.terms';
      //   }
      // }
      if (this.$route.params.title || this.$route.query.title) {
        title = this.$route.params.title || this.$route.query.title;
      }
      if (this.customHeaderText) {
        title = this.customHeaderText;
      }
      return this.$t(title);
    },
    isCheckMobile() {
      if (checkMobile() || isApp()) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {},
  methods: {
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...shopMapActions([
      shopTypes.FETCH_SHOP,
      shopTypes.SHOP_FOLLOW,
      shopTypes.SHOP_UNFOLLOW,
    ]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    async toggleFollow(shop, id) {
      const self = this;
      const funAutoEstimationInProgress = async () => {
        await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
          userId: self.currentUser.id,
          storeId: id,
        });
      };
      const funToggle = async function() {
        await self[
          shop.followed ? shopTypes.SHOP_UNFOLLOW : shopTypes.SHOP_FOLLOW
        ]({ id: id });
        await self[shopTypes.FETCH_SHOP]({ id: id });
      };
      if (shop.followed) {
        await funAutoEstimationInProgress();
        if (self.autoEstimation.id) {
          self[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message:
              '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
            okCb: async () => {
              await funToggle();
              //this.$router.go(-1);
            },
          });
        } else {
          await funToggle();
        }
      } else {
        await funToggle();
      }
    },

    handleBack() {
      this.$emit('back-icon-click');
    },
    handleMain() {
      this.$emit('main-icon-click');
    },
    handleAlarm() {
      this.$emit('alarm-click');
    },
    handleExitChatroom() {
      this.$emit('exit-click');
    },
    handleMyPage: function() {
      this.$emit('mypage-icon-click');
      //this.target = 'mypage';
    },
    handleSearch: function() {
      this.$emit('search-icon-click');
      //this.target = 'mypage';
    },
    handleClose: function(linkName) {
      this.$emit('close-icon-click', linkName);
      //this.target = 'mypage';
    },
    handleRegion: function() {
      this.$emit('region-icon-click', this.user);
      //this.target = 'mypage';
    },
    handleShare: function() {
      this.$emit('share-icon-click');
      //this.target = 'mypage';
    },
    handleKnowhowMy: function() {
      this.$emit('knowhow-my-icon-click');
      //this.target = 'mypage';
    },
    estimateInfoModal: function(listType) {
      this.$emit('estimate-info-click', listType);
      //this.target = 'mypage';
    },
  },
  created() {},
};
</script>
<style scoped></style>
